import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardImg,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import photo from "../../../assets/kangaroo/Australian.png";
import MediaService from "../../../services/KangarooServices/MediaServices";
import { imageBaseApi } from "../../../utilis/imageHelper.js";


const MediaDetail = ({ isOpen, toggle, selectedItem }) => {
  console.log("🚀 ~ MediaDetail ~ selectedItem:", selectedItem);
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);

  const fetchDetail = async () => {
    setLoading(true);
    try {
      const response = await MediaService.getDetail(selectedItem?.id);
      setData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedItem?.id) {
      fetchDetail();
    }
  }, [selectedItem?.id]);

  const renderMediaPreview = () => {
    if (!data?.url) return null;

    const fileType = data.mimeType || '';
    if (fileType.includes('image')) {
      // Display image
      return (
        <img
          src={`${imageBaseApi}${data.url}`}
          alt="media"
          className="img-fluid h-100 object-fit-contain rounded"
        />
      );
    } else if (fileType === 'application/pdf') {
      // Display PDF
      return (
        <iframe
          src={`${imageBaseApi}${data.url}`}
          title="PDF Preview"
          style={{ width: '100%', height: '100%', border: 'none' }}
        />
      );
    } else {
      // Fallback for other file types
      return <p className="text-center">Preview not available</p>;
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl">
      <ModalHeader toggle={toggle}>Attachment Detail</ModalHeader>

      <ModalBody>
        <Row className="gy-4">
          {/* Left: Media Preview */}
          <Col lg={7}>
            <Card className="shadow-sm border-0">
              <div
                className="d-flex justify-content-center align-items-center bg-light"
                style={{ height: '450px', borderRadius: '6px' }}
              >
                {renderMediaPreview()}
              </div>
            </Card>
          </Col>

          {/* Right: Details */}
          <Col lg={5}>
            <Card className="shadow-sm border-0">
              <CardBody>
                <h5 className="mb-3 fw-semibold">File Information</h5>

                <div className="mb-3">
                  <label className="text-muted small mb-1">File Name</label>
                  <p className="fw-semibold">{data?.fileName}</p>
                </div>

                <div className="mb-3">
                  <label className="text-muted small mb-1">Mime Type</label>
                  <p className="fw-semibold">{data?.mimeType}</p>
                </div>

                <div className="mb-3">
                  <label className="text-muted small mb-1">Size</label>
                  <p className="fw-semibold">
                    {(data?.size / 1024 / 1024).toFixed(2)} MB
                  </p>
                </div>

                <div className="mb-3">
                  <label className="text-muted small mb-1">Uploaded At</label>
                  <p className="fw-semibold">
                    {new Date(data?.uploadedAt).toLocaleString()}
                  </p>
                </div>

                <hr />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default MediaDetail;
